// extracted by mini-css-extract-plugin
export var gif = "_kx-0";